<template>
  <div class="ad3-bg" v-lazy-background lazy-background="./assets/imgs/comp-ad3-bg.webp">
    <div class="wrapper ad3">
      <div class="left">
        <div class="left-wraper">
          <!-- 骨架层 -->
          <div v-if="showSkeleton" class="skeleton-overlay">
            <svg t="1752816727647" class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6322" width="64" height="64"><path d="M0 0h1024v1024H0V0z" fill="#FAFAFA" p-id="6323" /><path d="M391.723044 854.548389h-18.006088v11.59023h18.006088v-11.59023z" fill="#DADADA" p-id="6324" /><path d="M398.764177 887.107965l-21.035044-28.848708h15.079079l22.450974 28.848708h-16.495009zM176.99115 833.526938h-21.304637v-11.621947h57.640779v11.621947h-22.136071v53.671646h-14.200071v-53.671646zM233.84354 821.904991v17.605097h13.808141c4.043894 0 7.226903 0.308106 9.544496 0.933381 2.319858 0.623009 4.277239 1.701381 5.878938 3.228319 3.035752 2.738973 4.569487 7.35377 4.601204 13.826265v29.707328h-13.413947v-27.124673c0-2.553204-0.124602-4.365593-0.37154-5.457558a5.81777 5.81777 0 0 0-1.447646-2.777486c-1.341168-1.400071-3.898903-2.122761-7.689062-2.152213h-10.917381v37.505133h-13.413947v-65.293593h13.420744zM280.265628 839.510088h13.413947v47.695293h-13.413947v-47.695293zM306.955327 839.510088h25.903576c3.851327 0 6.803257 0.269593 8.860318 0.81331 2.057062 0.541451 3.896637 1.549593 5.530053 3.008567 3.429947 3.033487 5.140389 7.86577 5.14039 14.496849v29.36977h-13.413947v-30.851398c0-2.356106-0.539186-4.057487-1.617558-5.09508-1.078372-1.039858-2.843186-1.558655-5.28538-1.558655h-11.703505v37.505133h-13.413947v-47.697557 0.009061z" fill="#DADADA" p-id="6325" /><path d="M396.877027 837.989947l-16.048708 22.074903 12.566654 3.289486 19.977062-25.364389h-16.495008zM378.39292 821.904991h-13.413947v65.30039h13.413947v-65.30039zM286.976 801.379681c-8.706265 0-15.772319 6.893876-15.772319 15.407576 0 8.511434 7.059257 15.407575 15.772319 15.407575 8.713062 0 15.772319-6.896142 15.772319-15.407575 0-8.513699-7.059257-15.407575-15.772319-15.407576z m0 21.533452c-3.466195 0-6.270867-2.74577-6.270867-6.125876 0-3.380106 2.811469-6.125876 6.270867-6.125876 3.459398 0 6.270867 2.74577 6.270867 6.125876 0 3.380106-2.811469 6.125876-6.270867 6.125876zM289.071575 797.623504h-4.207009a1.76708 1.76708 0 0 1-1.787469-1.744424v-10.273983c0-0.962832 0.801982-1.74669 1.787469-1.74669h4.207009c0.985487 0 1.787469 0.783858 1.787469 1.74669v10.273983a1.76708 1.76708 0 0 1-1.787469 1.744424zM277.220814 799.852743l-3.219256 2.641558a1.823717 1.823717 0 0 1-2.519222-0.217487l-6.764743-7.872566a1.726301 1.726301 0 0 1 0.222018-2.462584l3.221522-2.641558a1.823717 1.823717 0 0 1 2.519221 0.217487l1.055717 1.227894 5.709026 6.644672a1.724035 1.724035 0 0 1-0.224283 2.462584zM296.744779 799.852743l3.221522 2.641558a1.823717 1.823717 0 0 0 2.519221-0.217487l6.764743-7.872566a1.724035 1.724035 0 0 0-0.224283-2.462584l-3.219256-2.641558a1.823717 1.823717 0 0 0-2.519222 0.217487l-1.379681 1.610761-5.378265 6.261805a1.724035 1.724035 0 0 0 0.224283 2.462584h-0.009062z" fill="#DADADA" p-id="6326" /><path d="M438.380743 887.198584l27.66839-65.300389h16.404389l27.666124 65.300389h-16.694372l-6.465699-15.113062h-25.416495l-6.465699 15.113062h-16.696638z m35.896638-49.607363l-9.544496 22.865558h19.045947l-9.501451-22.865558zM555.563044 839.510088v10.19016h-16.109876c-5.355611 0-9.091398 1.182584-11.211894 3.53869-1.993628 2.23377-2.988177 5.613876-2.988177 10.138053 0 5.131327 1.633416 8.851257 4.900248 11.146195a11.954973 11.954973 0 0 0 4.361062 1.964177c1.563186 0.353416 3.751646 0.527858 6.563115 0.527858h14.492319v10.19016h-18.359505c-4.931965 0-8.828602-0.489345-11.703504-1.461239-2.874903-0.969628-5.432637-2.686867-7.689062-5.14039-4.175292-4.560425-6.270867-10.348743-6.270867-17.36269 0-8.481982 2.510159-14.827611 7.541805-19.041416 1.986832-1.687788 4.392779-2.890761 7.197451-3.613451 2.802407-0.715894 6.447575-1.076106 10.917381-1.076107h18.359504zM599.687929 858.213947c0-3.350655-0.693239-5.609345-2.079717-6.767009-1.386478-1.166726-4.107327-1.74669-8.151221-1.74669h-22.722832v-10.19016h22.722832c4.043894 0 6.848566 0.067965 8.398159 0.217487 1.547327 0.142726 3.112779 0.450832 4.675965 0.933381 7.412673 2.738973 10.933239 9.295292 10.577558 19.659894v26.884531h-28.307257c-5.061097 0-8.559009-0.142726-10.500531-0.428177-1.941522-0.287717-3.645168-0.910726-5.115469-1.866762-3.982726-2.612106-5.971823-6.556319-5.971823-11.816778 0-3.221522 0.79292-6.082832 2.37423-8.58846 1.579044-2.505628 3.665558-4.200212 6.23915-5.09508 2.288142-0.797451 6.087363-1.196177 11.411257-1.196177h16.449699z m0 10.183363h-15.52538l-2.249629-0.04531c-1.533735 0-2.750301 0.398726-3.651964 1.196177-0.901664 0.797451-1.347965 1.866761-1.347965 3.205664 0 1.565451 0.545982 2.664212 1.640213 3.305345 1.09423 0.638867 2.967788 0.956035 5.609345 0.956035h15.52538V868.39731zM658.305133 839.510088v-17.605097h13.413947v65.30039h-23.114761c-4.698619 0-8.228248-0.353416-10.577558-1.053452-5.74754-1.753487-10.024779-5.21515-12.829451-10.38046-1.893947-3.506973-2.84092-7.752496-2.840921-12.727504 0-8.194265 2.802407-14.555752 8.420815-19.086726 3.658761-2.965522 8.620177-4.44715 14.884247-4.447151h12.643682z m0 37.496071V849.693451h-9.691752c-4.277239 0-7.528212 1.384212-9.746124 4.161699-1.896212 2.392354-2.843186 5.457558-2.843186 9.182018 0 5.389593 1.579044 9.249982 4.746194 11.576637 2.18846 1.594903 4.798301 2.392354 7.834054 2.392354h9.700814zM739.713133 839.510088h49.364955c4.506053 0 7.926938 0.314903 10.255859 0.956036 2.333451 0.638867 4.28177 1.782938 5.854018 3.445805 2.936071 3.124106 4.408637 7.428531 4.408637 12.91554v30.377912h-13.413947v-28.323116c0-2.294938-0.108743-3.889841-0.317168-4.786973a5.178903 5.178903 0 0 0-1.393275-2.437664c-1.372885-1.309451-3.475257-1.957381-6.318442-1.95738h-7.149876v37.505133h-13.413947v-37.505133h-14.447009v37.505133h-13.413947v-47.695293h-0.015858zM815.251257 839.757027l19.854725 49.607362h13.629168l-17.836177-49.607362h-15.647716z" fill="#DADADA" p-id="6327" /><path d="M870.902938 839.757027L842.287575 903.929204h-13.47738l26.451823-64.172177h15.64092zM728.718726 858.39292v4.712213c0 2.965522-2.458053 5.366938-5.493806 5.366938h-25.801628a0.575434 0.575434 0 0 0-0.577699 0.632071c0.337558 2.77069 1.347965 4.74846 3.010832 5.953699 1.796531 1.293593 4.700885 1.941522 8.706265 1.941522h18.946266v10.092743h-20.400708c-3.853593 0-6.98223-0.330761-9.385912-0.992283-2.410478-0.663788-4.698619-1.798796-6.864424-3.409558-5.856283-4.426761-8.783292-11.028389-8.783293-19.811681v-7.532743c0-8.747044 7.265416-15.828956 16.21862-15.806301l14.238584 0.015858c8.975858 0.142726 16.171044 7.285805 16.171044 16.053239v2.784283h-11.325168l-0.022655-3.830938c-0.015858-2.920212-2.451257-5.283115-5.439433-5.276318h-9.832213c-2.91115 0.009062-5.285381 2.310796-5.292177 5.163044l-0.015858 3.328a0.573168 0.573168 0 0 0 0.577699 0.602619l31.349805 0.013593h0.015859z" fill="#DADADA" p-id="6328" /><path d="M457.084602 404.819823c-0.040779 0.589027-0.176708 0.971894-0.285452 1.193912l-92.871362-0.360213a3.02669 3.02669 0 0 1-0.142726-0.987752v-129.148602l0.006796-0.262796c0.040779-0.525593 0.197097-0.912991 0.337558-1.153133l92.955186-9.807292v140.525876z" fill="#ECECEC" p-id="6329" /><path d="M584.975858 199.371894c0.684177-0.04531 1.091965 0.122336 1.266407 0.226548v126.128708c-0.006796 0.004531-0.015858 0.013593-0.029451 0.018124a0.269593 0.269593 0 0 1-0.106478 0.018124h-0.126867l-0.126867 0.006797-147.702938 8.303009c-0.654726 0.015858-0.994549-0.149522-1.130478-0.240142V221.122832a1.227894 1.227894 0 0 1 0.330761-0.430443c0.188035-0.176708 0.425912-0.344354 0.686442-0.475752 0.258265-0.135929 0.484814-0.203894 0.632071-0.231079l146.307398-20.61593z" fill="#ECECEC" p-id="6330" /><path d="M663.753628 285.727717h0.043045l0.040778 0.004531c0.002265 0.002265 0.013593 0 0.049841 0.020389 0.04531 0.02492 0.131398 0.088354 0.240142 0.217487a2.084248 2.084248 0 0 1 0.434973 1.155398l0.031717 0.559575v130.256425a1.762549 1.762549 0 0 1-0.348885 0.994549 0.514265 0.514265 0 0 1-0.081558 0.086088c-0.004531 0.006796-0.013593 0.006796-0.018123 0.009062l-120.190868 1.067044-0.419115 0.002266-0.14046 0.027186c-0.036248-0.004531-0.058903-0.006796-0.072496-0.011328a0.108743 0.108743 0 0 1-0.027185-0.018124V275.052743c0.02492-0.577699 0.233345-0.876743 0.342088-0.985486 0.031717-0.031717 0.058903-0.047575 0.072496-0.056638l120.04361 11.717098z" fill="#ECECEC" p-id="6331" /><path d="M606.894442 393.56715c0.002265 0.013593 0.006796 0.029451 0.006797 0.04531v107.125805a1.150867 1.150867 0 0 1-0.065699 0.294514c-0.011327 0.027186-0.029451 0.04531-0.040779 0.063433l-98.680071 6.916531c-0.002265-0.013593-0.006796-0.027186-0.006796-0.043044V392.60885a0.695504 0.695504 0 0 1 0.040779-0.16085c0.013593-0.033982 0.033982-0.058903 0.04984-0.083823l98.695929 1.202973zM560.250336 549.840425c0.009062 0.027186 0.022655 0.065699 0.024921 0.122336v94.502513l-85.87554-13.882902-0.002266-0.004531-0.009062-0.043045v-88.693805l85.861947 7.999434z" fill="#ECECEC" p-id="6332" /></svg>
          </div>
          <!-- 单张图片 -->
          <template v-if="dataList.length === 1">
            <img
              v-if="!showVideo"
              v-lazy-load
              :data-not-lazy="$attrs.index < 2"
              v-lazy-load :data-src="dataList[0].imageUrl"
              :alt="dataList[0].webAltInfo"
              @load="onLoaded"
            >
            <div v-if="dataList[0].videoUrl && !showVideo" class="left-fixed-play" @click="handlePlayClick(dataList[0]?.videoTyp === 'youtube' ? 'youtube': 'html5')" />
            <template v-if="dataList[0].videoUrl && showVideo">
              <template v-if="dataList[0].videoType && dataList[0].videoType === 'youtube'">
                <iframe
                  class="video-iframe"
                  v-lazy-load :data-src="`${dataList[0].videoUrl}?autoplay=1`"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                />
              </template>
              <template v-else>
                <div v-show="showVideo" class="think-video-box">
                  <video-player v-if="dataList[0].videoUrl" ref="videoFixedPlayer" :options="videoOptions" class="vjs-theme-fantasy" />
                </div>
              </template>
            </template>
          </template>

          <!-- swiper -->
          <template v-else>
            <div v-swiper:mySwiper="swiperOption" class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in dataList"
                  :key="index"
                  class="swiper-slide"
                >
                  <img
                    class="swiper-lazy"
                    :data-src="item.imageUrl"
                    :alt="item?.webAltInfo || ''"
                    @load="onLoaded"
                  >
                  <div v-if="item.videoUrl" class="left-play" @click="handleClick(index)" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination" />
          </template>
        </div>
      </div>
      <div class="right">
        <div class="right-title">
          <div class="text-overflow-ellipsis title font-semibold-new">
            {{ title }}
          </div>
          <div class="text-overflow-ellipsis-2 describe">
            {{ describe }}
          </div>
        </div>
        <div v-if="buttonName" class="ad2-bottom">
          <DiffLinkLabel v-if="skipType != 1" :url="buttonUrl" :target="linkTarget">
            <div class="button btn-wraper" @click="buttonTrackReport({ buttonName })">
              <div class="ad2-btn text-overflow-ellipsis">
                {{ buttonName }}
              </div>
            </div>
          </DiffLinkLabel>
          <div v-else class="button btn-wraper" @click="toGn(buttonName)">
            <div class="ad2-btn text-overflow-ellipsis">
              {{ buttonName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <VideoPopup ref="videoPopup" />
    <YoutubeVideoPopup ref="youtubeVideoRef" :video-url="youtubeVideoUrl" />
  </div>
</template>

<script>
/**
 * 广告样式（三）
 */
import mixin from './mixin'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import trackReportMixin from '../Common/CommonMixin/trackReport'
import linkTargetMixin from '../Common/CommonMixin/linkTarget'
import VideoPopup from 'components/common/VideoPopup/index';
import DiffLinkLabel from '../Common/DiffLinkLabel/web.vue'
import bus from 'common/bus'
import VideoPlayer from 'components/common/VideoPlayer/index';
import YoutubeVideoPopup from 'components/common/YoutubeVideoPopup/index'

export default {
  name: 'Ad3',
  /* eslint-disable-next-line */
  components: { VideoPopup, DiffLinkLabel, Swiper, SwiperSlide, VideoPlayer, YoutubeVideoPopup, },
  directives: {
    swiper: directive,
  },
  mixins: [mixin, trackReportMixin, linkTargetMixin],
  data() {
    return {
      showSkeleton: true,
      youtubeVideoUrl: '',
    }
  },
  computed: {
    swiperOption() {
      const vm = this;
      return {
        slidesPerView: 'auto',
        loop: true,
        preloadImages: false,
        // loopAdditionalSlides: 1, // 仅复制前后1项，减少冗余
        loopedSlides: this.dataList.length, // 动态匹配数据长度
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        lazy: {
          enabled: true, // 显式开启懒加载（关键）
          loadPrevNext: true,
          loadPrevNextAmount: 2, // 预加载前后各2项
        },
        speed: 500,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          init() { // 初始化完成后触发
            vm.bindClonePlayEvents();
          },
          slideChange() { // 滑动后重新绑定（可选）
            vm.bindClonePlayEvents();
          },
        },
      };
    },
  },

  mounted() {
    const bgEl = this.$el;
    const bgImg = new Image();
    // eslint-disable-next-line global-require
    bgImg.src = require('./assets/imgs/comp-ad3-bg.webp');
    bgImg.onload = () => {
      bgEl.style.backgroundColor = 'transparent';
    };
  },
  methods: {
    handlePlayClick(type) {
      console.log('视频类型', type)
      this.showVideo = true;
      if (type === 'youtube') {
        this.showVideo = true;
      } else {
        this.$refs.videoFixedPlayer?.play();
      }
      this.cardTrackReport();
    },
    handleClick(index = 0) {
      // console.log('点击了播放按钮', index)
      this.handleToPlay(index)
    },
    // 为了解决 Swiper 循环模式（loop: true）下的初始克隆元素未正确绑定事件
    bindClonePlayEvents() {
      // 获取所有播放按钮（包括克隆的）
      const playBtns = document.querySelectorAll('.left-wraper .left-play');
      playBtns.forEach((btn, i) => {
        // 移除旧事件，避免重复绑定
        btn.removeEventListener('click', this.handleCloneClick);
        // 绑定新事件，通过索引计算原始数据索引
        btn.addEventListener('click', () => this.handleCloneClick(i));
      });
    },
    handleCloneClick(cloneIndex) {
      // 计算原始数据索引（循环模式下克隆元素的索引映射）
      const realIndex = cloneIndex % this.dataList.length;
      // console.log('克隆元素触发播放', realIndex);
      this.handleToPlay(realIndex);
    },
    toGn(buttonName) {
      this.buttonTrackReport({ buttonName })
      if (!this.isLogin) {
        if (this.functionType === 1) {
          bus.$emit('login', { triggerSource: 'down' });
          return
        }
        bus.$emit('login', { triggerSource: 'appointment' });
        return
      }
      if (this.functionType === 1 && this.triageComponentId) {
        this.$router.push(`/triage-desk/${this.triageComponentId}`);
        return
      }
      bus.$emit('toShowDiagnosis')
    },
    onLoaded() {
      this.showSkeleton = false;
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.swiper-pagination {
  position: relative;
  margin-top: 10px;

  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    opacity: 0.1;
    margin-right: 10px;
  }

  .swiper-pagination-bullet-active {
    background-color: var(--txt-color-link);
    opacity: 1;
  }
}

.ad3-bg {
  padding: 50px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #ffe9c6;
}

.ad3 {
  display: flex;
  justify-content: center;
}

.left {
  .left-wraper {
    width: 491px;
    height: 348px;
    padding: 9px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 19px;
    position: relative;

    .skeleton-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 16px;
      background: linear-gradient(90deg, rgb(242, 242, 242) 25%, rgb(230, 230, 230) 37%, rgb(242, 242, 242) 63%) 0% 0% / 400% 100%;
      animation: 1.4s ease 0s infinite normal none running skeleton-loading;
      background-size: 400% 100%;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        fill: rgb(220, 221, 224);
        width: 22%;
        height: 22%;
      }
    }

    img,
    .video-iframe {
      width: 473px;
      height: 330px;
      border-radius: 16px;
      z-index: 1;
      position: relative;
      overflow: hidden;
    }

    .think-video-box {
      width: 473px;
      height: 330px;
      border-radius: 16px;
      z-index: 1;
      position: relative;

      .vjs-theme-fantasy {
        width: 100%;
        height: 100%;

        // --vjs-theme-fantasy--primary: #9173ff;

        ::v-deep .video-js {
          width: auto;
          height: 100%;
          border-radius: 16px;
        }
      }
    }
  }

  .swiper-container {
    width: 473px;

    .swiper-slide {
      width: 473px;
      height: 330px;
      position: relative;
    }
  }

  .left-play,
  .left-fixed-play {
    width: 52px;
    height: 52px;
    position: absolute;
    cursor: pointer;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    background-image: url('./assets/imgs/play.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0 50%;
    }
  }
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 70px;

  .right-title {
    color: var(--txt-color-lv1);
    cursor: default;

    .title {
      width: 460px;
      font-size: 40px;
      font-family: Roboto-Flex, sans-serif;
      margin-bottom: 10px;
      color: var(--txt-color-lv4);
    }

    .describe {
      width: 460px;
      font-size: 18px;
      font-family: Roboto-Regular, sans-serif;
      line-height: 32px;
      font-weight: 400;
    }
  }
}

.ad2-bottom {
  max-width: 364px;
  display: flex;

  .btn-wraper {
    border-radius: 30px;
    font-size: 22px;
    font-family: Roboto-Flex, sans-serif;
    font-weight: bold;
    line-height: 16px;
    background: var(--txt-color-link);

    .ad2-btn {
      max-width: 364px;
      min-width: 200px;
      padding: 22px;
    }

    &:hover {
      background: var(--txt-color-link2);
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
}
</style>
